// extracted by mini-css-extract-plugin
export var aiStarIcon = "_tz-2";
export var container = "_tz-4";
export var dismissButton = "_tz-3";
export var hasPaddingBottom = "_tz-6";
export var last = "_tz-e";
export var scrollbarThumb = "_tz-c";
export var scrollbarTrack = "_tz-b";
export var selected = "_tz-9";
export var spin = "_tz-1";
export var spinning = "_tz-0";
export var suggestionItem = "_tz-d";
export var suggestionsPanel = "_tz-5";
export var tonePill = "_tz-8";
export var tonesContainer = "_tz-7";
export var unselected = "_tz-a";